module.exports = function() {
  return new Worker(__webpack_public_path__ + "2d4481de02d5b2634843.worker.js");
};